import React, { useState } from 'react';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import HomePage from './Pages/HomePage';
import ServicesPage from './Pages/ServicesPage';
import AboutPage from './Pages/AboutPage';
import TeamPage from './Pages/TeamPage';
import ContactPage from './Pages/ContactPage';
import PortfolioPage from './Pages/PortfolioPage'; // New Import
import './Styles/App.css'; // Import the custom CSS file

const App = () => {
  const [currentPage, setCurrentPage] = useState('home');

  // Render the current page based on state
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage setCurrentPage={setCurrentPage} />;
      case 'services':
        return <ServicesPage setCurrentPage={setCurrentPage} />;
      case 'about':
        return <AboutPage />;
      case 'team':
        return <TeamPage />;
      case 'contact':
        return <ContactPage />;
        case 'portfolio': // New case for Portfolio page
        return <PortfolioPage />;
      default:
        return <HomePage setCurrentPage={setCurrentPage} />;
    }
  };

  return (
    <div className="font-sans antialiased">
      {/* Tailwind CSS CDN - Best practice is to include this in public/index.html for React */}
      {/* <script src="https://cdn.tailwindcss.com"></script>
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap" rel="stylesheet" /> */}
      <style>
        {`
          body {
            font-family: 'Inter', sans-serif;
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            background-color: #f8fafc; /* A very light blue-gray for overall background */
          }
          #root {
            display: flex;
            flex-direction: column;
            min-height: 100vh;
          }
          .page-content {
            flex-grow: 1;
          }
          @media (max-width: 767px) {
            .carousel-desc {
              display: none
            }
          }
        `}
      </style>

      <Navbar setCurrentPage={setCurrentPage} currentPage={currentPage} />
      <main className="page-content">
        {renderPage()}
      </main>
      <Footer />
    </div>
  );
};
export default App;
